import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

class DateWithOptions extends Component {
  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
  }

  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined);
  }

  getLocaleDate = (date, yearFormat, monthFormat, dayFormat, locale) => {
    const options = {
      year: yearFormat,
      month: monthFormat,
      day: dayFormat
    };
    return new Date(date).toLocaleString(locale, options);
  };

  returnLocaleDate = date => {
    const { messages } = this.props.intl;
    const { locale } = this.props;
    const { yearFormat, monthFormat, dayFormat } = messages.dateOptions;
    return this.getLocaleDate(date, yearFormat, monthFormat, dayFormat, locale);
  };

  render() {
    const { messages } = this.props.intl;
    const { yearFormat, monthFormat, dayFormat } = messages.dateOptions;
    const { locale } = this.props;
    return this.props.isComponent ? <span>{this.getLocaleDate(this.props.date, yearFormat, monthFormat, dayFormat, locale)}</span> : "";
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return {
    locale
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    {}
  )(DateWithOptions)
);
